var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.popular)?_c('span',{staticClass:"popular"},[_vm._v("Most Popular")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"months"},[_vm._v(_vm._s(_vm.months))]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("months")]),_vm._v(" "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm.price/100))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666a8999","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/RegimenChecker/steps/PackageItem.vue
// module id = hga6
// module chunks = 37